<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :title="$t('ChangeCharge.ChangeCharge')"
    width="1300px"
    :before-close="cancel"
    class="main-content change-charge-window"
  >
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        config-module="19110101"
        :row-data="rowData"
        min-height="300px"
      />
    </div>
    <div v-if="editable" slot="footer">
      <div style="float: right;margin-bottom: 10px">
        <el-button type="primary" size="mini" no="1" @click="saveEvent">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button size="mini" no="2" @click="cancel">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceMultipleSelectEditor
  from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getLoading } from '@/utils/utilBaseElement'
import { batchCreateChangeCharge } from '@/api/clearing/changeCharge'
import { deepClone } from '@/utils'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import { Job } from '@/class/model/booking/Job'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'

export default {
  name: 'ChangeChargeDetailDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    editable: { type: Boolean, required: true }, // 是否编辑
    source: { type: Array, required: true }, // 弹框打开时默认传递条件
    inputIncludingTaxUnitPrice: { type: Number, default: 0 } // 单价是否含税
  },
  data() {
    return {
      userId: 0,
      officeId: 0,
      departmentId: 0,
      selectTypeNames: TYPE_NAMES,
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor,
          CargoAgGridCommonTextareaEditor
        },
        onRowClicked: this.rowClicked
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('ChangeCharge.jobNo'), field: 'jobNo',
          colId: 'jobNo', width: 140 },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              staticOptions: [...this.currentViewCacheData.chargeItemSet],
              methodParams: this.getChargeItemFilter(params.data),
              tagValue: 'itemId',
              tagName: this.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('ChangeCharge.actionType'), field: 'actionType',
          colId: 'actionType',
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeActionTypeLabFun(params.value)
          }, width: 90 },
        {
          headerName: this.$t('ChangeCharge.changeReason'),
          editable: (params) => this.editable,
          colId: 'changeReason',
          field: 'changeReason',
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_settleAccountsTo'),
          colId: 'accountId',
          field: 'accountId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true },
              autoKey: 'auto_0',
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                return true
                // return this.config.isInputChargeBaseOnService
              },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('FinanceManage.charge_invoiceHeader'), field: 'invoiceTitle', width: 140 },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.internal') }, { code: true, value: this.$t('SeaExport.overseas') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_drawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currentViewCacheData.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000000')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 6
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'), colId: 'measure', field: 'measure', initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              methodParams: { unit: true, seaFreight: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          colId: 'excludingTaxAmount1',
          field: 'excludingTaxAmount',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax',
          field: 'unitPriceIncludeTax',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && params.data.actionType !== 2 && !!this.inputIncludingTaxUnitPrice,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }],
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          hide: !this.inputIncludingTaxUnitPrice,
          suppressColumnsToolPanel: !this.inputIncludingTaxUnitPrice
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        },
        {
          headerName: this.$t('FinanceManage.charge_contactPerson'),
          colId: 'contactPerson',
          field: 'contactPerson',
          initialWidth: 180,
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = this.currentViewCacheData.companyContactPersonMap.get(params.data.accountId)
            return {
              selectProps: {
                tagValue: 'contactPerson',
                tagName: 'contactPerson',
                staticOptions,
                filterable: true,
                filterTagNames: ['contactPerson']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
          editable: (params) => this.editable && params.data.actionType !== 2,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ],
      isAr: false,
      lob: '',
      loading: false,
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        companyContactPersonMap: new Map(), // company对应的联系人map 缓存
        companyCmpIdxForCustomerMap: new Map(), // 结算单位
        chargeMeasureSet: new Set(), // 费用单位
        mblCargoDocSet: new Set(), // 关单号set
        hblCargoDocSet: new Set(), // 关单号set
        officeIdForDepartmentMap: new Map(),
        officeIdForClearDepartmentMap: new Map(), // 结算公司
        currencySet: new Set(),
        userAllSet: new Set(), // cache中取得全部用户集合
        containerNoAllSet: new Set(), // 全部箱号
        user4AuditorSet: new Set(), // 审核人数据集合
        paymentTermSet: new Set(),
        customerDefaultTitleMap: new Map(), // 委托单位和默认发票抬头
        customerTitlesMap: new Map(), // 委托单位和关联的发票抬头
        customerSettlementAgentMap: new Map(), // 结算对象关联的结算代理
        chargeItemSet: new Set() // 收费项目
      },
      jobMap: {} // 业务对象缓存
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    language() {
      return this.$store.getters.language === 'zh'
    },
    rowData() {
      return deepClone(this.source)
    }
  },
  created() {
    this.userId = this.$store.getters.userId
    this.officeId = this.$store.getters.currentOfficeId
    this.departmentId = this.$store.getters.currentDeptId
    this.initializeHandler()
    this.onShow()
  },
  methods: {
    // 初始化权限及配置参数
    async initializeHandler() {
    },
    async onShow() {
      this.initCurrencySet()
      this.initChargeItemSet()
    },
    async saveEvent() {
      const changeCharges = []
      const rows = this.rowData.filter(p => p.actionType !== 2)
      if (rows && rows.length > 0) {
        if (!await ChargeUtils.checkUnitRate(rows, this)) {
          return
        }
      }
      for (const item of this.rowData) {
        // 校验值
        if (!this.validateCharge(item)) {
          return
        }
        const changeCharge = {}
        changeCharge.changeReason = item.changeReason
        changeCharge.branchId = this.$store.getters.currentOfficeId
        changeCharge.actionType = item.actionType
        item.uuid = item.chargeUuid
        item.branchId = this.$store.getters.currentOfficeId
        changeCharge.chargeVO = item
        changeCharges.push(changeCharge)
      }
      this.toApplyCharge(changeCharges)
    },
    async onCellChange(params) {
      console.log('cellChange', params)
      const newParams = {
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        originalValue: params.oldValue
      }
      await this.chargeGridItemEditEndHandler(newParams)
    },
    async chargeGridItemEditEndHandler(params) {
      console.log('cellChange', params)
      const job = await this.getJob(params.data.jobUuid)
      await ChargeColumnUtil.changeChargeCellChangeHandler(params, job, this.currentViewCacheData, this.inputIncludingTaxUnitPrice)
      this.gridOptions.api.refreshCells({ force: true })
    },
    cancel() {
      this.$emit('close')
    },
    // 费用项目过滤
    getChargeItemFilter(charge) {
      switch (charge.jobLob) {
        case 'SE':
          return { seaExport: true }
        case 'SI':
          return { seaImport: true }
        case 'AE':
          return { airExport: true }
        case 'AI':
          return { airImport: true }
        case 'RE':
        case 'RI':
          return { railwayExport: true }
        default:
          return {}
      }
    },
    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currentViewCacheData.currencySet = new Set(results)
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.currentViewCacheData.chargeItemSet = new Set(results)
    },
    /**
     * 获取业务对象
     * @param jobUuid
     * @returns {Promise<Object|{}|*>}
     */
    async getJob(jobUuid) {
      if (this.jobMap.hasOwnProperty(jobUuid)) {
        return this.jobMap[jobUuid]
      }
      const jobData = new Job({ uuid: jobUuid })
      await jobData.loadJobRelated({ job: true })
      this.jobMap[jobUuid] = jobData._data
      return jobData._data
    },
    toApplyCharge(changeCharges) {
      this.loading = getLoading()
      console.log('applyCharge', changeCharges)
      batchCreateChangeCharge(changeCharges).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
        this.cancel()
        this.$emit('returnCall')
      }).finally(() => {
        this.loading.close()
      })
    },
    // 保存费用校验
    validateCharge(charge) {
      if (charge.actionType !== 2) {
        if (isNaN(charge['accountId']) || Number(charge['accountId']) <= 0) {
          this.$message.warning(this.$t('Message.SettlementPartyCannotBeNull'))
          return false
        }
        if (isNaN(charge['chargeItemId']) || Number(charge['chargeItemId']) <= 0) {
          this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
          return false
        }
        if (isNaN(charge['quantity']) || Number(charge['quantity']) === 0) {
          this.$message.warning(this.$t('Message.AmountCannotBeZero'))
          return false
        }
        if (isNaN(charge['exchangeRate']) || Number(charge['exchangeRate']) === 0) {
          this.$message.warning(this.$t('Message.ExchangeCannotBeZero2'))
          return false
        }
        if (charge['remarks'] && charge['remarks'].length > 50) {
          this.$message.warning(this.$t('Message.RemarkTheLengthCannotExceed'))
          return false
        }
      }
      if (!charge.changeReason) {
        this.$message.warning(this.$t('ChangeCharge.changeReasonCannotBeNull'))
        return false
      }
      if (charge.changeReason.length > 100) {
        this.$message.warning(this.$t('ChangeCharge.changeReasonIsTooLong'))
        return false
      }
      return true
    }

  }
}
</script>
<style lang="scss">
  .change-charge-window {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
